export default {
  root: {
    display: 'none',
  }
};
